import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    view: [],
    totalItems: 0,
    userDataOptions: [],
    documents: [],
    lastRequestId: 0
  },
  getters: {
    error: (state) => state.error,
    totalItems: (state) => state.totalItems,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view,
    getUserDataOptions: (state) => state.userDataOptions,
    filterUserDataOptionsByIds: (state) => array => {
      let result = []
      array.forEach(id => {
        result.push(state.userDataOptions.filter(user => {
          return user['@id'] === id
        })[0])
      })
      return result
    },
    documents: (state) => state.documents,
    lastRequestId: (state) => state.lastRequestId
  },
  mutations: {
    reset (state) {
      state.items = []
      state.view = []
    },
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setLoading (state, loading) {
      state.isLoading = loading
    },
    setItems (state, items) {
      state.items = items
    },
    setTotalItems (state, totalItems) {
      state.totalItems = totalItems
    },
    setView (state, view) {
      state.view = view
    },
    setUserDataOptions (state, payload) {
      state.userDataOptions = payload
    },
    setDocuments (state, payload) {
      state.documents = payload
    },
    setLastRequestId (state, payload) {
      state.lastRequestId = payload
    }
  },
  actions: {
    async fetchCases ({ commit, state }, url = 'e_x_c_m_cases') {
      commit('setLoading', true)
      let currentRequestId = state.lastRequestId + 1
      commit('setLastRequestId', currentRequestId)
      const response = await new ApiService(url).getResults()
      if (currentRequestId !== state.lastRequestId) {
        return
      }
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('setTotalItems', await response.totalItems)
      commit('setLoading', false)
    },
    async fetchUserDataOptions ({ commit }) {
      let params = {
        pagination: false,
        isContractor: 1
      }
      const response = await new ApiService('user_datas/list', params).getResults()
      commit('setUserDataOptions', await response.items)
    },
    async fetchDocuments ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_documents', baseParams).getResults()
      commit('setDocuments', response.items)
    }
  }
}
